import { fits } from "./constants";

export enum Status {
  SUCCESS = "SUCCESS",
  LOADING = "LOADING",
  FALLBACK = "FALLBACK",
}

export type Fit = typeof fits[number];
